<mat-card class="status-signal-20">
  <div class="w-full text-center mb-4">
    {{ positionName }}の山留変位が管理基準値を超えました。
  </div>
  <div class="w-full text-center">計測箇所を確認してください。</div>
</mat-card>
